import { ThemeOptions } from "@mui/material/styles";

export const themeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: "#fbdc6a",
    },
    secondary: {
      main: "#ec9340",
    },
    background: {
      default: "#1c1711",
      paper: "#231b15",
    },
    text: {
      primary: "#fcdc6a",
      secondary: "#ec9340",
    },
  },
  components:{
    MuiButton: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color:"#575757"
          }
        }
      }
    }
  },
  typography: {
    fontFamily: "Assistant",
    h2: {
      fontFamily: "Martel",
    },
    button: {
      fontWeight: 600,
    },
    h1: {
      fontFamily: "Martel",
    },
    h3: {
      fontFamily: "Martel",
    },
    h4: {
      fontFamily: "Martel",
    },
    h5: {
      fontFamily: "Martel",
    },
    h6: {
      fontFamily: "Martel",
    },
  },
  shape: {
    borderRadius: 0,
  },
};
